import DataTable from 'components/ui/DataTable/data-table';
import Modal from 'components/ui/Modal/modal';
import PrimaryButton from 'components/ui/PrimaryButton';
import SecondaryButton from 'components/ui/SecondaryButton';
import React, { FC, useState } from 'react';
import { Cell } from 'react-table';
import { toast } from 'react-toastify';
import {
  ITraineeDetail,
  ITraineeStatus,
  useApproveTraineeMutation,
  useListPendingTraineeQuery,
  useListRejectedTraineeQuery,
  useRejectTraineeMutation
} from 'redux/reducers/user';
import { useNavigate } from 'react-router-dom';
import { backendURL, baseApiUrl } from 'redux/reducers/settings';
import { useGetActiveRoutine } from 'service/admin.query';
import CustomSelect from 'components/ui/Editor/CustomSelect';

interface IUserManagementTable {
  tableHeaders?: () => React.ReactNode;
  status: string;
  allID: Array<string>;
  setAllID: React.Dispatch<React.SetStateAction<string[]>>;
}

const UserManagementTable: FC<IUserManagementTable> = ({
  tableHeaders,
  status,
  allID,
  setAllID
}) => {
  const [userDetail, setUserDetail] = useState<ITraineeDetail | null>(null);
  const [isReject, setIsReject] = useState<boolean>(false);
  const [selectedRoutine, setselectedRoutine] = useState<any>()

  // const { data: userList = [], isLoading: isPendingLoading } = useListPendingTraineeQuery({});
  // const { data: rejectedUserList = [], isLoading: isRejectedLoading } = useListRejectedTraineeQuery(
  //   {}
  // );
  let navigate = useNavigate();

  const { data: pendingResp, isLoading: isPendingLoading } = useListPendingTraineeQuery({});
  const { data: rejectedResp, isLoading: isRejectedLoading } = useListRejectedTraineeQuery({});

  const [approveTrainee, { isLoading }] = useApproveTraineeMutation();
  const [rejectTrainee, { isLoading: rejectLoading }] = useRejectTraineeMutation();
  const [showDetail, setShowDetail] = useState<boolean>(false);
  const handleToggleDetail = () => setShowDetail((prev) => !prev);
  const { data: activeRoutine = [], isLoading: isLoadingRoutine } = useGetActiveRoutine('active', true)

  const onApproveUser = async () => {
    if (!userDetail) return;

    try {
      await approveTrainee({ id: userDetail.id.toString(), routine_id: selectedRoutine }).unwrap();
      setUserDetail(null);
      toast.success('Trainee approved successfully!');
    } catch (error) {
      toast.error('Failed to approve trainee!');
    }
  };
  const onRejectUser = async () => {
    if (!userDetail) return;

    try {
      await rejectTrainee({ id: userDetail.id.toString() }).unwrap();
      setIsReject(false);
      setUserDetail(null);
      toast.success('Trainee rejected successfully!');
    } catch (error) {
      toast.error('Failed to reject trainee!');
    }
  };

  const handleCheckbox = (id: string) => () => {
    const item = allID.find((item) => item == id);

    item
      ? setAllID((prev) => prev.filter((item) => item != id))
      : setAllID((prev) => [...prev, id]);
  };
  const columns = [
    {
      Header: 'C.B',
      Cell: (cell: Cell<ITraineeDetail>) => {
        return (
          <input
            type="checkbox"
            className="form-check-input"
            checked={
              !!allID.length && allID?.some((item: any) => item == cell.row.original.id)
                ? true
                : false
            }
            id="mastercheck"
            onChange={handleCheckbox(cell.row.original.id.toString())}
          />
        );
      }
    },
    {
      Header: 'S.N',
      accessor: 'sn',
      Cell: (cell: Cell) => {
        return cell.row.index + 1;
      }
    },
    {
      Header: ' First Name',
      accessor: 'first_name'
    },
    {
      Header: ' Last Name',
      accessor: 'last_name'
    },
    {
      Header: 'Email',
      accessor: 'user_details.email'
    },
    {
      Header: 'Mobile Number',
      accessor: 'mobile_number'
    },

    {
      Header: '  Action',
      Cell: (data: Cell<ITraineeDetail>) => {
        return (
          <div className='d-flex gap-2'>
            {+data.row.original?.user_details.status == ITraineeStatus.Pending ? (
              <div>
                <PrimaryButton
                  title="Approve"
                  type="button"
                  small="btn-sm mx-2"
                  onClick={() => setUserDetail(data.row.original)}
                />
                <PrimaryButton
                  isDanger
                  title="Reject"
                  type="button"
                  small="btn-sm"
                  onClick={() => {
                    setIsReject(true);
                    setUserDetail(data.row.original);
                  }}
                />
              </div>
            ) : +data.row.original?.user_details.status == ITraineeStatus.Rejected ? (
              <PrimaryButton
                title="Approve"
                type="button"
                small="btn-sm mx-2"
                onClick={() => setUserDetail(data.row.original)}
              />
            ) : (
              ''
            )}
            {data.row.original?.recommendation_letter ? <a href={backendURL + data.row.original?.recommendation_letter} target="_blank" className=''>
              <PrimaryButton
                title="View Recommendation"
                type="button"
                small="btn-sm mx-2"
              />
            </a> : ""}
          </div>
        );
      }
    }
  ];
  const pendingList = Array.isArray(pendingResp) ? pendingResp : [];

  const rejectedList = Array.isArray(rejectedResp) ? rejectedResp : [];

  return (
    <div>
      <DataTable
        columns={columns}
        data={status === 'pending' ? pendingList : rejectedList}
        isLoading={status === 'pending' ? isPendingLoading : isRejectedLoading}
        tableHeaders={tableHeaders}
      />

      <Modal
        title="Approve Trainee"
        isModalOpen={!isReject && !!userDetail}
        closeModal={() => setUserDetail(null)}
        modalSize="modal-md"
        renderFooter={() => (
          <div className="hstack gap-2 justify-content-end">
            <SecondaryButton onClick={() => setUserDetail(null)} title="Cancel" />
            <PrimaryButton
              type="button"
              title="Approve"
              onClick={onApproveUser}
              isLoading={isLoading}
            />
          </div>
        )}>
        <h4 className="fw-bold">
          Are you sure you want to approve{' '}
          {`${userDetail?.first_name ?? ''} ${userDetail?.last_name ?? ''}`}?
        </h4>

        <CustomSelect
          containerClassName='col-12'

          options={activeRoutine && activeRoutine?.map((item: any) => ({ label: `${item?.training_details?.training_name} - ${item?.batch_name} - ${item?.hall_details?.hall_name}`, value: item?.routine_master_id }))}
          placeholder={'Routine'}
          value={selectedRoutine}
          onChange={(value: any) =>
            setselectedRoutine(value)

          }

          label={'Select Routine you want to enroll selected trainee '}
        />
      </Modal>
      <Modal
        title="Reject Trainee"
        isModalOpen={isReject && !!userDetail}
        closeModal={() => {
          setIsReject(false);
          setUserDetail(null);
        }}
        modalSize="modal-md"
        renderFooter={() => (
          <div className="hstack gap-2 justify-content-end">
            <SecondaryButton
              onClick={() => {
                setIsReject(false);
                setUserDetail(null);
              }}
              title="Cancel"
            />
            <PrimaryButton
              type="button"
              title="Reject"
              onClick={onRejectUser}
              isLoading={rejectLoading}
            />
          </div>
        )}>
        <h4 className="fw-bold">
          Are you sure you want to reject{' '}
          {`${userDetail?.first_name ?? ''} ${userDetail?.last_name ?? ''}`}?
        </h4>
      </Modal>
    </div>
  );
};

export default UserManagementTable;
